import { createEffect } from "effector/compat";
import { restPostHandler } from "@utils/rest/RestClient";
import { CguBodyRequestDto } from "@state/cgu/dto/request/cgu.body.request.dto";
import configuration from "@utils/Config";

const baseUrl = configuration.backendBaseUrl;
const officeCguUrl = baseUrl + "/ws/fo/office/cgu";

export const requestCreateOfficeCgu = createEffect({
  handler: restPostHandler<CguBodyRequestDto, void>(officeCguUrl),
});
